import React, { Component, Fragment } from 'react';

import ConnectedVendorReturnModal from './VendorReturnModal';

const VendorReturnModalCreate = () => {
  const [isOpen, setIsOpen] = React.useState(false);

  return (
    <>
      <button
        type="button"
        title="New vendor return"
        id="newVendorReturnButton"
        data-test="create-vendor-return-open-button"
        onClick={() => setIsOpen(true)}
      >
        <i className="icon-plus green" /> New vendor return
      </button>
      <ConnectedVendorReturnModal
        isCreateMode
        isOpen={isOpen}
        handleCloseModal={() => setIsOpen(false)}
      />
    </>
  );
};

export default VendorReturnModalCreate;
